/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-location-exists';

export const EntityLocationExistApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/multi`, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async () => {
    const url = pathname;

    try {
      const response = await entityService.get(`${url}/filter`);

      return response;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeMulti: async (ids: string[]) => {
    const url = `${pathname}/multi/remove-entity-location-exists`;

    try {
      const response = await entityService.patch(url, {
        entityLocationExistIDs: ids,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeAllByOwnerID: async () => {
    const url = `${pathname}/remove-all-entity-location-exists`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
